export default __webpack_public_path__ + "static/media/Jai-Vilas-Palace_600-1280x720-1.f27ddbce.jpg";